const API_BASE = process.env.VUE_APP_BASE_API || (process.env.NODE_ENV === 'development' ? 'http://localhost:8109/api' : 'https://qingquan.rwan.org.cn/api')
const PLACEHOLDER = '/static/images/wells/placeholder.svg'

function normalizeImagePath(url) {
  if (!url) return ''
  return String(url).trim()
    .replace(/\/wly\/api\/v1(\/images\/)/, '$1')
    .replace(/\/wly(\/images\/)/, '$1')
    .replace(/^https?:\/\/(192\.168\.\d+\.\d+|localhost|127\.0\.0\.1)(:\d+)?(\/)/i, '$3')
}

function isInvalidImageUrl(url) {
  if (!url) return true
  const value = normalizeImagePath(url)
  return !value || /^(https?:\/\/)?tmp\//i.test(value) || /example\.com/i.test(value)
}

export function resolveImageUrl(url) {
  if (isInvalidImageUrl(url)) return PLACEHOLDER

  const trimmed = normalizeImagePath(url)
  if (/^https?:\/\//i.test(trimmed)) return trimmed

  if (/^\/static\/images\/wells\/.+\.(png|jpe?g|webp)$/i.test(trimmed)) {
    return PLACEHOLDER
  }

  if (trimmed.startsWith('/static/')) return trimmed

  if (trimmed.startsWith('/')) {
    return API_BASE + trimmed
  }

  return API_BASE + '/' + trimmed
}

export function resolveImageList(list) {
  if (!Array.isArray(list)) return []
  return list.map(item => resolveImageUrl(item)).filter(Boolean)
}

/**
 * 把完整 URL 还原为后端存储的相对路径，供编辑表单提交时使用。
 * 例：http://host/api/images/abc.jpg → /images/abc.jpg
 */
export function unresolveImageUrl(url) {
  if (!url) return url
  const trimmed = String(url).trim()
  if (trimmed.startsWith(API_BASE)) {
    return trimmed.slice(API_BASE.length) || '/'
  }
  return trimmed
}

export function unresolveImageList(list) {
  if (!Array.isArray(list)) return []
  return list.map(item => unresolveImageUrl(item)).filter(Boolean)
}
